// Links in the header and footer that go to another site (like NTA Home, to
// the gym site) open in a new tab, so shoppers keep their place in the shop.
// Shopify's menu editor has no new-tab option. Screen readers hear that the
// link opens a new tab.

for (const link of document.querySelectorAll('#header-group a[href], .page-wrapper > footer a[href]')) {
  let url;
  try {
    url = new URL(link.href, window.location.href);
  } catch {
    continue;
  }
  if (!/^https?:$/.test(url.protocol) || url.hostname === window.location.hostname) continue;
  if (link.target === '_blank') continue;

  link.target = '_blank';
  link.rel = [link.rel, 'noopener'].filter(Boolean).join(' ');

  const note = document.createElement('span');
  note.className = 'visually-hidden';
  note.textContent = ' (opens in a new tab)';
  link.append(note);
}
